import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { ElearningReviewersStateType } from '@/modules/types/elearningReviewers';

export const elearningReviewersAdaptor = createEntityAdapter();

const initialState: ElearningReviewersStateType =
  elearningReviewersAdaptor.getInitialState({
    currentReviewerId: '',
    tmsUserId: 0,
    isReviewerModalOpen: false,
  });

interface ReviewerIdType {
  reviewerId: string;
}

interface TmsIdType {
  tmsUserId: number;
}

const elearningReviewersSlice = createSlice({
  name: 'elearningReviewers',
  initialState,
  reducers: {
    openReviewerModal: (state) => {
      state.isReviewerModalOpen = true;
    },
    closeReviewerModal: (state) => {
      state.isReviewerModalOpen = false;
      state.currentReviewerId = '';
      state.tmsUserId = 0;
    },
    setCurrentReviewerId: (state, action: PayloadAction<ReviewerIdType>) => {
      state.currentReviewerId = action.payload.reviewerId;
    },
    setTmsUserId: (state, action: PayloadAction<TmsIdType>) => {
      state.tmsUserId = action.payload.tmsUserId;
    },
  },
});

export const { name, actions, reducer } = elearningReviewersSlice;
